var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutMLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 132,
    viewBox: "0 0 138 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 47C129.66 54.2061 120.543 60.12 110.871 65.4031C98.7067 72.0468 86.6681 78.8473 73.7747 84.0057C61.7974 88.7976 49.9453 93.0818 38.4927 99.0955C31.4297 102.804 24.5409 107.494 18.2005 112.329C14.9645 114.797 12.2422 116.936 9.34943 119.805C5.03609 124.082 3.64795 125.55 1 131",
    stroke: "#C9C1AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 131C28.1325 121.799 44.2336 117.499 58.1297 111.794C77.1269 103.994 90.8952 91.467 100.357 73.1362C107.787 58.7413 113.983 43.775 121.762 29.5429C129.541 15.3109 138 1 138 1",
    stroke: "#650D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMLine2);
export default __webpack_public_path__ + "static/media/aboutMLine2.70613aa0d46cd4fb421e078a520fffc3.svg";
export { ForwardRef as ReactComponent };